export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://eft-assured-early.ngrok-free.app/api/api';

export const COURSE_DIFFICULTY_COLORS = {
  beginner: 'green',
  intermediate: 'orange',
  advanced: 'red',
} as const;

export const USER_ROLES = {
  STUDENT: 'student',
  INSTRUCTOR: 'instructor',
  ADMIN: 'admin',
} as const;

export const COURSE_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
} as const;

export const LESSON_TYPES = {
  VIDEO: 'video',
  TEXT: 'text',
  QUIZ: 'quiz',
  ASSIGNMENT: 'assignment',
} as const;

export const QUIZ_QUESTION_TYPES = {
  MULTIPLE_CHOICE: 'multiple-choice',
  TRUE_FALSE: 'true-false',
  FILL_BLANK: 'fill-blank',
  CODE: 'code',
} as const;

export const ROUTES = {
  DASHBOARD: '/dashboard',
  COURSES: '/courses',
  MY_COURSES: '/my-courses',
  COURSE_DETAIL: '/course/:id',
  LESSON: '/course/:courseId/lesson/:lessonId',
  PROFILE: '/profile',
  LOGIN: '/login',
  REGISTER: '/register',
} as const;

export const LOCAL_STORAGE_KEYS = {
  USER: 'icer_lms_user',
  TOKEN: 'icer_lms_token',
  THEME: 'icer_lms_theme',
} as const;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 12,
  PAGE_SIZE_OPTIONS: ['12', '24', '48'],
} as const;

export const COURSE_FILTERS = {
  DIFFICULTY: ['beginner', 'intermediate', 'advanced'],
  DURATION: ['0-5', '5-10', '10-20', '20+'],
  PRICE: ['free', '0-50', '50-100', '100-200', '200+'],
} as const;